/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timecode_Shrink_StretchInputs */

const en_timecode_shrink_stretch = /** @type {(inputs: Timecode_Shrink_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode Shrink/Stretch`)
};

const fr_timecode_shrink_stretch = /** @type {(inputs: Timecode_Shrink_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réduire/étirer le timecode`)
};

const de_timecode_shrink_stretch = /** @type {(inputs: Timecode_Shrink_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode-Verkleinerung/Verlängerung`)
};

const it_timecode_shrink_stretch = /** @type {(inputs: Timecode_Shrink_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riduzione/allungamento del codice temporale`)
};

const ru_timecode_shrink_stretch = /** @type {(inputs: Timecode_Shrink_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сжатие/растяжение таймкода`)
};

const es_timecode_shrink_stretch = /** @type {(inputs: Timecode_Shrink_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reducir/estirar el código de tiempo`)
};

const zh_cn2_timecode_shrink_stretch = /** @type {(inputs: Timecode_Shrink_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间码收缩/拉伸`)
};

const ja_timecode_shrink_stretch = /** @type {(inputs: Timecode_Shrink_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコードの縮小/拡大`)
};

const hi_timecode_shrink_stretch = /** @type {(inputs: Timecode_Shrink_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड को छोटा/बड़ा करना`)
};

const pt_pt2_timecode_shrink_stretch = /** @type {(inputs: Timecode_Shrink_StretchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encolhimento/Alongamento do código de tempo`)
};

/**
* | output |
* | --- |
* | "Timecode Shrink/Stretch" |
*
* @param {Timecode_Shrink_StretchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timecode_shrink_stretch = /** @type {((inputs?: Timecode_Shrink_StretchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timecode_Shrink_StretchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timecode_shrink_stretch(inputs)
	if (locale === "de") return de_timecode_shrink_stretch(inputs)
	if (locale === "it") return it_timecode_shrink_stretch(inputs)
	if (locale === "ru") return ru_timecode_shrink_stretch(inputs)
	if (locale === "es") return es_timecode_shrink_stretch(inputs)
	if (locale === "zh-CN") return zh_cn2_timecode_shrink_stretch(inputs)
	if (locale === "ja") return ja_timecode_shrink_stretch(inputs)
	if (locale === "hi") return hi_timecode_shrink_stretch(inputs)
	if (locale === "pt-PT") return pt_pt2_timecode_shrink_stretch(inputs)
	return en_timecode_shrink_stretch(inputs)
});